<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.keyword"
        placeholder="请输入关键字"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in BANK_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        @click="checkDialogFormVisible(true, {}, 'CREATE')"
        >新增</el-button
      >
    </div>

    <div style="margin-bottom: 5px">银行数量:{{ total }}</div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" prop="id" label="ID" width="95"></el-table-column>
      <el-table-column label="银行名称" align="center" prop="bankName"></el-table-column>
      <el-table-column label="银行logo" align="center" prop="bankLogo">
        <template slot-scope="scope">
          <el-image :src="getTableThumbnailImg(scope.row.bankLogo)" fit="cover"></el-image>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="状态" align="center">
        <template slot-scope="scope">
          {{ getValue(BANK_STATUS, scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="ctdate" label="创建时间" width="160px">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="mddate" label="修改时间" width="160px">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="230"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="checkDialogFormVisible(true, scope.row, 'UPDATE')"
            >编辑</el-button
          >
          <el-button
            :type="scope.row.status === 0 ? 'success' : 'danger'"
            size="mini"
            @click="checkStatus(scope.row)"
            >{{ scope.row.status === 0 ? "启用" : "停用" }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!--    编辑和新增-->
    <el-dialog
      :title="DIALOG_TITLE_TYPE[dialogType]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="50%"
      top="60px"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="150px"
        style="width: 90%; margin-left:50px;"
      >
        <el-form-item label="银行名称" prop="bankName">
          <el-input v-model="form.bankName" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="银行LOGO" prop="bankLogo">
          <UploadList
            :typeProps="UPLOAD_IMG_TYPE.COMMON"
            @valueFunc="getImgsValueFunc"
            paramsType="bankLogo"
            :model="form.bankLogo"
            :maxCount="1"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkDialogFormVisible(false, {}, '')">取消</el-button>
        <el-button type="primary" @click="saveAddOrEditData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBankList, editBank, switchBankStatus } from "@/api/system.js";
import { getFileName, formatApiDate, getTableThumbnailImg } from "@/utils/utils";
import { DIALOG_TITLE_TYPE, getValue, UPLOAD_IMG_TYPE, BANK_STATUS } from "@/utils/enumUtile";
import UploadList from "@/views/components/uploadList.vue";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    },
    UPLOAD_IMG_TYPE() {
      return UPLOAD_IMG_TYPE;
    },
    BANK_STATUS() {
      return BANK_STATUS;
    }
  },
  components: { UploadList },
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        keyword: null,
        status: null
      },
      dialogFormVisible: false,
      dialogType: "",
      rules: {
        bankName: [{ required: true, message: "银行名称不能为空", trigger: "change" }],
        bankLogo: [{ required: true, message: "银行LOGO不能为空", trigger: "change" }]
      },
      form: {
        id: 0,
        bankName: null,
        bankLogo: []
      },
      btnLoading: false
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    getValue,
    getTableThumbnailImg,
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 查询用户列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      getBankList(params)
        .then(response => {
          if (response && response.bizcode === 100) {
            this.list = response.data.entitys;
            this.total = response.data.totalCount;
          }
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 切换状态
     * @param status
     * @param editObj
     * @param type
     */
    checkDialogFormVisible(status, editObj = {}, type) {
      if (status && type === "UPDATE") {
        this.form.id = editObj.id;
        this.form.bankName = editObj.bankName;

        if (editObj.bankLogo) {
          const attDataArr = [];
          attDataArr.push({
            url: editObj.bankLogo,
            dbUrl: editObj.bankLogo,
            name: getFileName(editObj.bankLogo)
          });
          this.form.bankLogo = attDataArr;
        }
      }
      if (!status) {
        this.form.id = 0;
        this.form.bankName = null;
        this.form.bankLogo = [];
        this.$refs.form.resetFields();
      }
      this.dialogType = type;
      this.dialogFormVisible = status;
    },

    /**
     * 确认添加还是编辑
     */
    saveAddOrEditData() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const form = this.form;
          const params = {
            bankName: form.bankName
          };
          if (form.bankLogo && form.bankLogo.length !== 0) {
            const urlArr = form.bankLogo.map(obj => obj["dbUrl"]);
            params.bankLogo = urlArr.join(",");
          }
          if (form.id && form.id !== 0) {
            params.id = form.id;
          }
          console.log("params", params);
          this.btnLoading = true;
          editBank(params)
            .then(resp => {
              if (resp && resp.bizcode === 100) {
                this.getList();
                this.checkDialogFormVisible(false);
                this.$notify({
                  title: "成功",
                  message: "保存成功",
                  type: "success",
                  duration: 2000
                });
              }
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },
    /**
     *  获取图片的值
     * @param type
     * @param value
     */
    getImgsValueFunc(type, value) {
      if (type === "bankLogo") {
        this.form.bankLogo = value;
      }
    },
    /**
     * 编辑状态
     */
    checkStatus(row) {
      const deleteGoodsMsg = row.status === 0 ? "确认要启用该银行？" : "确认要停用该银行？";
      this.$confirm(deleteGoodsMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const params = {
          id: row.id,
          status: row.status === 1 ? 0 : 1
        };
        switchBankStatus(params).then(resp => {
          if (resp && resp.bizcode === 100) {
            this.getList();
            this.$notify({
              title: "成功",
              message: "修改成功",
              type: "success",
              duration: 2000
            });
          }
        });
      });
    }
  }
};
</script>
<style scoped lang="scss">
.box-card {
  margin-bottom: 10px;
}
</style>
